import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function profileReducer (state=initialState.profile, action) {
    switch (action.type) {
        case types.PROFILE__GET_SUCCESS:
            return {...state, ...action.response, loaded: true};
        case types.LOGOUT__USER_SUCCESS:
            return {...initialState.profile};
        case types.PROFILE__UPDATE_DELIVERY:
            return {...state, ...action.options, isDeliveryUpdated: true};
        case types.PROFILE__UPDATE_MOBILE_PHONE_SUCCESS:
            return {...state, ...action.payload.profile};
        case types.PROFILE__UPDATE_NAME_SUCCESS:
            return {...state, ...action.payload.profile};
        default:
            return state;
    }
}